module.exports = __webpack_public_path__ + "649f230c2ba88383e0ff226cf622ee12.svg";